import React, {useEffect} from "react";
import {useParams} from 'react-router-dom';

import * as T from 'utils/types';
import { 
    Button,
    Select,
    Skeleton,
    List,
    Grid
} from "antd";
import {useDispatch, useSelector} from "react-redux";
import TotalResult from "components/panel/TotalResult";
import profilePg_scopusTab_S, { profilePg_scopusTab_Thunks } from "./scopusTabSlice"

import Error500 from "components/errors/Error500";
import ToHomeButton from "components/ToHomeButton";
import PublicationTitle from "components/publication/PublicationTitle";
import PublicationDescription from "components/publication/PublicationDescription";
import "features/content/search_page/components/TabBlock/PubTab/AltmetricBadge.css";

const {Option}=Select;

// ProfilePage ScopusTab
export default () => {
    const screens = Grid.useBreakpoint();
    const breakpoint = screens.md;

    useEffect(() => {
        // _altmetric_embed_init is offered by Altmetric in embeded.js file
        // this func will let js to find new altmetric-embed div and fetch the data for them
        // eslint-disable-next-line
        eval('if(typeof _altmetric_embed_init!="undefined"){_altmetric_embed_init();}');
    })

    const { randomID } = useParams<{ randomID: string }>();


    const {
        total,
        status,
        hasNext,
        pubList,
        yearFilter:{ years, year, total:total_yearFilter, status: status_yearFilter},
        sortType
    } = useSelector((state: T.RootState) => state.profilePg_scopusTab);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(profilePg_scopusTab_Thunks.initList({randomID, year, sortType}));
    }, [dispatch, randomID, year, sortType]);

    useEffect(() => {
        dispatch(profilePg_scopusTab_Thunks.rPubYearStat({randomID}));
    }, [dispatch, randomID]);

    if (status==="failed") {
        return (<Error500 extra={<ToHomeButton/>}/>);
    }

    const sortButtons = (
        <>
            <Button
                className="sub-heading-font"
                type="text"
                style={{ fontSize: '13px', color: '#888', marginBottom: 4 }}
                onClick={ () => {
                    if ( sortType !== '-date' ) {
                        dispatch(
                            profilePg_scopusTab_S.actions.setSortType('-date')
                        );
                    }
                }}>
                Sort by date {sortType === '-date' && '\u2193'}
            </Button>
            <Button
                className="sub-heading-font"
                type="text"
                style={{ fontSize: '13px', color: '#888', marginBottom: 4 }}
                onClick={ () => {
                    if (sortType !== '-cited_by_count') {
                        dispatch(
                            profilePg_scopusTab_S.actions.setSortType('-cited_by_count')
                        );
                    }
                }}>
                Sort by citation {sortType === '-cited_by_count' && '\u2193'}
            </Button>
            <Button
                className="sub-heading-font"
                type="text"
                style={{ fontSize: '13px', color: '#888', marginBottom: 4 }}
                onClick={ () => {
                    if (sortType !== '-altmetric_score') {
                        dispatch(
                            profilePg_scopusTab_S.actions.setSortType('-altmetric_score')
                        );
                    }
                }}>
                Sort by Altmetric score {sortType === '-altmetric_score' && '\u2193'}
            </Button>
        </>
    );

    return <>
        {total>=0&&<TotalResult searchResult={total}/>}

        {total_yearFilter>=0&&<Select
            className="sub-heading-font"
            value={year}
            style={{ width:200, marginRight: 8, marginBottom: 4 }}
            //selectEntries={publicationYearOptions}
            onChange={ value => {
                dispatch(
                    profilePg_scopusTab_S.actions.setYear(value)
                );
            }}
            loading={status_yearFilter!=="succeeded"}
            disabled={status_yearFilter!=="succeeded"}
            filterOption={(input, option) => (option !== undefined) && 
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
        >
            {[
                <Option className="sub-heading-font" value={-1} key={-1}>
                    {`All years (${total_yearFilter})`}
                </Option>,
                ...(years.map( x => 
                <Option className="sub-heading-font" value={x.year} key={x.year}>
                    {`${x.year} (${x.cnt})`}
                </Option>))
            ]}
        </Select>}

        {breakpoint ? <>{sortButtons}</> : (
            <div style={{ display: 'flex', overflowX: 'scroll' }}>
                {sortButtons}
            </div>
        )}

         <List
            loading={status==="idle"}
            itemLayout="horizontal"
            loadMore={
                hasNext ? <div
                    style={{
                        textAlign: 'center',
                        marginTop: 12,
                        height: 32,
                        lineHeight: '32px',
                    }}
                >
                    <Button
                        className="sub-heading-font"
                        onClick={() => dispatch(profilePg_scopusTab_Thunks.loadMore({randomID}))}
                    >
                        More
                    </Button>
                </div> : null
            }
            dataSource={pubList}
            renderItem={ item => {
                const pub = item.item as T.Publication;
                return <List.Item>
                    <Skeleton avatar title={false} loading={item.loading} active>
                        <List.Item.Meta

                            avatar={<div
                                    className='altmetric-embed'
                                    data-badge-type='donut'
                                    data-badge-popover="right"
                                    data-link-target='_blank'
                                    data-doi={pub?.DOI||"0"}
                                ></div>}

                            title={ <PublicationTitle publication={pub}/> }

                            description={ <PublicationDescription publication={pub}/> }

                        />
                    </Skeleton>
                </List.Item>;
            } }
        />

    </>;
}
